module.exports = __webpack_public_path__ + "img/heart.37249d72.svg";